/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProcessDefinitionPutV1Dto } from '../models/ProcessDefinitionPutV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProcessDefinitionsService {
  /**
   * @param includeVersions Should all versions be included in response, or just the newest?
   * @returns any
   * @throws ApiError
   */
  public static processDefinitionControllerV1ListV1(
    includeVersions: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/process-definitions',
      query: {
        includeVersions: includeVersions,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static processDefinitionControllerV1GetV1(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/process-definitions/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody The process definition to create or update
   * @returns any
   * @throws ApiError
   */
  public static processDefinitionControllerV1PutV1(
    id: string,
    requestBody: ProcessDefinitionPutV1Dto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v1/process-definitions/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param version
   * @returns any
   * @throws ApiError
   */
  public static processDefinitionControllerV1GetSpecificVersionV1(
    id: string,
    version: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/process-definitions/{id}/{version}',
      path: {
        id: id,
        version: version,
      },
    });
  }
  /**
   * @param id
   * @param version
   * @returns void
   * @throws ApiError
   */
  public static processDefinitionControllerV1DeleteV1(
    id: string,
    version: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/process-definitions/{id}/{version}',
      path: {
        id: id,
        version: version,
      },
    });
  }
}
